import {Injectable} from '@angular/core';
import {API_URLS} from 'src/environments/env-routes';
import {APIHelper} from 'src/shared/services/api-helper/api-helper.service';

@Injectable({
  providedIn: 'root'
})
export class CommentService {
  constructor(private api: APIHelper) {}

  createComment(data: any, id: string): Promise<any> {

    return this.api.requestApi({
      action: API_URLS.comment.create.replace(':nodeId', id),
      method: 'POST',
      datas: data
    });
  }
  getAllComment(id: string) {
    const queries = '?reverse=true&startIndex=0&pageSize=10';

    return this.api.requestApi({
      action: API_URLS.comment.getAll.replace(':nodeId', id),
      queryArgs: queries
    });
  }

  deleteComment(id: string) {
    return this.api.requestApi({
      action: API_URLS.comment.delete.replace(':nodeId', id),
      method: 'DELETE'
    });
  }
}
